import React, { Component } from 'react';

class ListItem extends Component {

  render() {
    var colClass = window.isRecipe ? "col-sm-4 col-xs-6" : "col-sm-3 col-xs-6"
    colClass = window.isThreeColumn ? "col-sm-4 col-xs-6" : colClass
    colClass = window.colClass ? window.colClass : colClass
    return (
      <div className={colClass}>
        {this.props.children}
      </div>
    );
  }
}

class ListSection extends Component {

  render() {
    var columns = window.isRecipe ? 3 : 4
    columns = window.isThreeColumn ? 3 : columns
    const rowCount = Math.ceil(this.props.items.length / columns)

    const rows = []

    for (var i = 0; i < rowCount; i++) {

      var items = []

      for (var j = 0; j < columns; j++) {
        const item = this.props.items[(i*columns)+j]
        if (item) {
          items.push(
            <ListItem>
              {item}
          </ListItem>
          )
        }
      }

       rows.push(items)
    }



    return (
    <div className="row">
      {rows}
    </div>
    );
  }
}

export  {
  ListItem,
  ListSection
}



// WEBPACK FOOTER //
// ./src/ListItem.js